import { all, takeLatest, fork, put, select } from 'redux-saga/effects';
import DishesApi from 'libs/api/dishes';
import routeCodes from 'common/constants/route-codes';
import UIHelper from 'services/UIHelper';
import * as types from './types';
import { setModalData } from '../common/actions';

function* getDishes({ payload }) {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new DishesApi(currentRestaurant?.id);

    const { data } = yield api.list({
      params: {
        per: 10000,
      },
    });
    yield put({
      type: types.DISHES_GET_SUCCESS,
      payload: data.dishes,
    });
  } catch (e) {
    yield put({
      type: types.DISHES_GET_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* getDishById({ payload }) {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new DishesApi(currentRestaurant?.id);
    const { data } = yield api.get(payload.id);
    yield put({
      type: types.DISHES_GET_BY_ID_SUCCESS,
      payload: data.dish,
    });
  } catch (e) {
    yield put({
      type: types.DISHES_GET_BY_ID_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* changeDishPosition({ payload }) {
  try {
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new DishesApi(currentRestaurant?.id);
    yield put({
      type: types.DISHES_CHANGE_POSITION_SUCCESS,
      payload: payload,
    });
    yield api.put(payload.id, { data: {
      position: payload.position + 1,
    } });
  } catch (e) {
    yield put({
      type: types.DISHES_CHANGE_POSITION_SUCCESS,
      payload: { originalPosition: payload.position, position: payload.originalPosition },
    });
  }
}

function* createOrUpdate({ payload }) {
  try {
    const { id, formData, history } = payload;
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new DishesApi(currentRestaurant.id);
    const response = id
      ? yield api.put(id, { data: formData })
      : yield api.create({
          data: formData,
          headers: { 'Content-Type': 'multipart/Form-data' },
        });
    yield put({
      type: types.DISHES_CREATE_OR_UPDATE_SUCCESS,
    });
    yield put({
      type: types.DISHES_GET_REQUEST,
    });
    UIHelper.showSuccessMessage();
    // UIHelper.showCreateOrUpdateSuccess();
    history?.push(routeCodes.menu);
  } catch (e) {
    yield put({
      type: types.DISHES_CREATE_OR_UPDATE_FAILURE,
      payload: e?.response?.data,
    });
  }
}

function* deleteRestaurant({ payload }) {
  try {
    const { id, history } = payload;
    const currentRestaurant = yield select(
      (state) => state.common.currentRestaurant,
    );
    const api = new DishesApi(currentRestaurant.id);
    yield api.destroy(id);
    yield put({
      type: types.DISHES_DELETE_SUCCESS,
    });
    yield put(
      setModalData({
        open: false,
        variant: 'primary',
        title: '',
        body: '',
        itemData: {},
      }),
    );
    UIHelper.showSuccessMessage();
    yield put({
      type: types.DISHES_GET_REQUEST,
      payload: {},
    });
    history?.push(routeCodes.menu);
  } catch (e) {
    yield put({
      type: types.DISHES_DELETE_SUCCESS,
      payload: e?.response,
    });
  }
}

function* watchDishCreateOrUpdate() {
  yield takeLatest(types.DISHES_CREATE_OR_UPDATE_REQUEST, createOrUpdate);
}

function* watchDishGetById() {
  yield takeLatest(types.DISHES_GET_BY_ID_REQUEST, getDishById);
}

function* watchChangeDishPosition(){
  yield takeLatest(types.DISHES_CHANGE_POSITION_REQUEST, changeDishPosition);
}

function* watchGetDishes() {
  yield takeLatest(types.DISHES_GET_REQUEST, getDishes);
}

function* watchDishDeleteRequest() {
  yield takeLatest(types.DISHES_DELETE_REQUEST, deleteRestaurant);
}



export default function* companySaga() {
  yield all([
    fork(watchDishCreateOrUpdate),
    fork(watchGetDishes),
    fork(watchDishDeleteRequest),
    fork(watchDishGetById),
    fork(watchChangeDishPosition),
  ]);
}
